<template>
  <page>
    <template v-slot:content>
      <v-container fluid py-0>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <noticeboard></noticeboard>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <activity></activity>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <!-- <feed></feed> -->
            <chat></chat>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </page>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import activity from './activity';
import chat from './chat';
import feed from './feed';
import noticeboard from './noticeboard';

export default {
  components: {
    activity,
    chat,
    feed,
    noticeboard
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      account: state => state.account
    })
  }
};
</script>
